import React from "react";

function PointsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M11.991 0c4.964 0 8.991 4.027 8.991 8.991 0 3.653-1.264 4.636-8.101 14.517-.421.656-1.405.656-1.826 0C4.218 13.674 3 12.644 3 8.991A8.964 8.964 0 0111.991 0zm0 12.738a3.757 3.757 0 003.747-3.747 3.727 3.727 0 00-3.747-3.746c-2.107 0-3.746 1.639-3.746 3.746a3.727 3.727 0 003.746 3.747z"
      ></path>
    </svg>
  );
}

export default React.memo(PointsIcon);
